import Subject from "../cse4sub/Subject";
import React from 'react'

export default function CnLab() {
  return (
    <div>
       <Subject title="Computer Network Lab(CSE606)" sub="CN Lab" syllabus="#"
    book1="TCP/IP Illustrated, Volume 1, W. Richard Stevens, and Addison-Wesley, United States of America."
     book2=" "
    book1Link="https://www.pdfdrive.com/download.pdf?id=3730514&h=b76dc37c213962f1f25c0e275dfa862a&u=cache&ext=pdf
    " book2Link="#" int21="#" mid21="#" end21="#"
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}